// 导入axios
import axios from "axios";
// 使用element-ui Message做消息提醒  Loading加载
import { Message, Loading } from "element-ui";
//请求头
import operate from "./operate";
//vuex
import store from '../store/index'
//路由
import router from '../router/index'

//1. 创建新的axios实例，
const service = axios.create({
    // 公共接口
    baseURL: operate.api(),
    // baseURL: '/api',
    // 超时时间 单位是ms，这里设置了3s的超时时间
    timeout: 120 * 1000
});

// 加载动画
let loadingInstance

// 2.请求拦截器
//http 请求 拦截器
service.interceptors.request.use((config) => {
    // 启动 加载动画
    loadingInstance = Loading.service({ fullscreen: true });
    //发请求前做的一些处理，数据转化，配置请求头，设置token,设置loading等，根据需求去添加
    // config.data = JSON.stringify(config.data); //数据转化,也可以使用qs转换

    // 配置请求头
    config.headers = {
        'Content-Type': 'application/x-www-form-urlencoded'
        // 'Content-Type': 'multipart/form-data'
    }
    //参数请求添加 拼接起来
    config.params = Object.assign({}, config.params, config.data)
    // config.params = config.data

    //判断是否有token
    const token = config.token;
    // console.log(token)
    if (token != undefined) {
        //参数请求添加 拼接起来
        config.params = Object.assign({}, config.params, config.data, operate.uploadParameters())
        //如果要求携带在参数中
        // config.params = { 'Authori-zation': token }
        // config.params = Object.assign({}, config.params, { 'Authori-zation': 'token ' + token })
        // 如果要求携带在请求头中
        // config.headers = Object.assign({}, config.headers, operate.uploadParameters())
        // config.headers.token = token;
    }
    // console.log("请求拦截器", config)
    return config
}, error => {
    Promise.reject(error)
})

// http 响应 拦截器
service.interceptors.response.use((response) => {
    // 关闭 加载动画
    loadingInstance.close();
    //410000  410001   410002 登录过期
    if (response.data.status == '410000' || response.data.status == '410001' || response.data.status == '410002') {
        Message.error("登录过期,请重新登录")
        //清除登录缓存
        store.commit("user/LOGOUT")
        //返回首页
        setTimeout(() => {
            router.push("/");
        }, 500);
    } else {
        //请求成功返回的参数
        return response.data
    }
}, error => {
    // 关闭 加载动画
    loadingInstance.close();
    /***** 接收到异常响应的处理开始 *****/
    if (error && error.response) {
        // 1.公共错误处理
        // 2.根据响应码具体处理
        switch (error.response.status) {
            case 400:
                error.message = '错误请求'
                break;
            case 401:
                error.message = '未授权，请重新登录'
                setTimeout(() => {
                    router.push("/");
                }, 500);
                break;
            case 403:
                error.message = '拒绝访问'
                break;
            case 404:
                error.message = '请求错误,未找到该资源'
                // window.location.href = "/NotFound"
                setTimeout(() => {
                    router.push("/404");
                }, 500);
                break;
            case 405:
                error.message = '请求方法未允许'
                break;
            case 408:
                error.message = '请求超时'
                break;
            case 500:
                error.message = '服务器端出错'
                break;
            case 501:
                error.message = '网络未实现'
                break;
            case 502:
                error.message = '网络错误'
                break;
            case 503:
                error.message = '服务不可用'
                break;
            case 504:
                error.message = '网络超时'
                break;
            case 505:
                error.message = 'http版本不支持该请求'
                break;
            default:
                error.message = `连接错误${error.response.status}`
        }
    } else {
        // 超时处理
        if (JSON.stringify(error).includes('timeout')) {
            error.message = '服务器响应超时，请刷新当前页'
        } else {
            error.message = '连接服务器失败'
        }
    }
    //提示
    Message.error(error.message)
    /***** 处理结束 *****/
    return Promise.resolve(error.response)
})

//导出
export default service